const EMAIL_REGEX = /.+@.+\..+/;

export const emailValid = (email: string): boolean => {
  if (email.trim().length === 0 || email.match(EMAIL_REGEX) === null) {
    return false;
  }
  return true;
};
